import React from 'react';
import { Content, CompositeTextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './SearchListRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.group.SearchListRenderer');
function SearchListRenderer(props) {
  const {
    variant,
    headerVariant,
    focusOnMount,
    search,
    post,
    refreshSearch,
    areaVariant,
    suggesters,
    listenForEnter,
    setSearch,
    onFocus
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: S.grow,
    onKeyPress: listenForEnter,
    children: /*#__PURE__*/_jsxs(Content, {
      variant: variant,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: headerVariant,
        children: /*#__PURE__*/_jsx(CompositeTextInput, {
          focus: focusOnMount,
          onFocus: onFocus,
          post: post,
          variant: variant || 'search',
          buttonProps: {
            onClick: refreshSearch
          },
          value: search,
          changeOnReturn: false,
          alwaysFireOnReturn: false,
          onChange: ({
            value
          }) => setSearch(value),
          hint: t('hint')
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: areaVariant,
        children: suggesters
      })]
    })
  });
}
export default {
  type: 'list',
  render: SearchListRenderer
};